import React from 'react';

import autoBind from 'react-autobind';
import { If, Then } from 'react-if'

// import other components within the same project here

import Localization from "../Localization.jsx"

import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Button } from '@material-ui/core';


class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
      open: false,
      titleText: Localization.strings.TITLE,
      contentText: Localization.strings.CONTENT,
      confirmText: Localization.strings.OK,
      cancelText: Localization.strings.CANCEL,
      confirmCallback: null,
      cancelCallback: null,
      confirmButtonColor: "primary",
    };
    autoBind(this);
  }

  show(dialogText, confirmCallback, cancelCallback) {
    if (dialogText) {
      let title = (dialogText.title? dialogText.title : Localization.strings.TITLE);
      let content = (dialogText.content? dialogText.content : Localization.strings.CONTENT);
      let confirm = (dialogText.confirm? dialogText.confirm : Localization.strings.OK);
      let cancel = (dialogText.cancel? dialogText.cancel : Localization.strings.CANCEL);
      let confirmButtonColor = (dialogText.confirmButtonColor? dialogText.confirmButtonColor : "primary");

      this.state.titleText = title;
      this.state.contentText = content;
      this.state.confirmText = confirm;
      this.state.cancelText = cancel;
      this.state.confirmButtonColor = confirmButtonColor;

      this.setState({
        titleText: title,
        contentText: content,
        confirmText: confirm,
        cancelText: cancel,
        confirmButtonColor: confirmButtonColor,
      });
    }
    this.state.confirmCallback = confirmCallback;
    this.state.cancelCallback = cancelCallback;
    this.state.open = true;
    this.setState({
      confirmCallback: confirmCallback,
      cancelCallback: cancelCallback,
      open: true,
    });
  }

  handleConfirmClicked() {
    if (this.state.confirmCallback) {
      this.state.confirmCallback();
    }
    this.handleClose();
  }

  handleCancelClicked() {
    if (this.state.cancelCallback) {
      this.state.cancelCallback();
    }
    this.handleClose();
  }

  handleClose() {
    this.setState({ open: false });
    this.state.open = false;
  }

  render() {
    return (
      <div>
        <Dialog
          open={this.state.open}
          fullWidth={true}
          maxWidth={'sm'}
          onClose={this.handleClose}
        >
          <DialogTitle>
            {this.state.titleText}
          </DialogTitle>
          <DialogContent>
            {this.state.contentText}
          </DialogContent>
          <DialogActions style={{padding:'16px 24px'}}>
            <If condition={this.state.cancelCallback != null}>
              <Then>
                <Button
                  onClick={this.handleCancelClicked}
                >
                  {this.state.cancelText}
                </Button>
              </Then>
            </If>
            <If condition={this.state.confirmCallback != null}>
              <Then>
                <Button
                  variant="contained"
                  color={this.state.confirmButtonColor}
                  onClick={this.handleConfirmClicked}
                >
                  {this.state.confirmText}
                </Button>
              </Then>
            </If>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

export default ConfirmDialog;
